<template>
  <div class="w-full bg-white shadow rounded flex px-4 py-2">
    <UtilPlaceholder class="h-24 mr-2 rounded" style="width: 100px;" />

    <div class="flex-auto">
      <UtilPlaceholder class="h-5 w-full mb-2" />
      <UtilPlaceholder class="h-3 w-4/12 mb-2" />

      <div class="flex">
        <UtilPlaceholder class="h-3 w-3/12 mr-2" />
        <UtilPlaceholder class="h-3 w-2/12" />
      </div>
    </div>
  </div>
</template>

<script>
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'

export default {
  name: 'UtilPlaceholderHitCardList',
  components: {
    UtilPlaceholder
  }
}
</script>
